<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="setAction" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-is-valid="props" :vm-active="isModalPaymentDateVisible" :vm-title='title')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-date-picker(type="date" label='Fecha de Pago' :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="paymentDate" style="width=100%;")
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Sales')

export default {
  name: 'ModalSalesPaymentDate',
  props: {
    title: {
      type: String,
      default: 'Fecha de Pago'
    },
    id: {
      type: Number,
      default: () => 0
    },
    props: {
      type: String,
      default: () => ''
    },
    action: {
      type: String,
      default: () => ''
    }
  },
  data: () => ({
    paymentDate: ''
  }),
  computed: {
    ...mapGetters([
      'isModalPaymentDateVisible'
    ]),
    payment_date () {
      return `?payment_date=${this.paymentDate}`
    }
  },
  methods: {
    ...mapActions([
      'actionSale',
      'setModalPaymentDateVisible'
    ]),
    setAction () {
      this.actionSale({ id: this.id, props: this.payment_date, action: this.action })
      this.paymentDate = ''
    },
    close () {
      this.setModalPaymentDateVisible(false)
    },
    handleChange (date) {
      this.paymentDate = date
    }
  }
}
</script>

<style>
.vm-select--options {
  z-index: 400331 !important;
}
a {
  cursor: pointer;
}
</style>
